import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col } from "react-bootstrap";
import profile from "../images/profile.png";
import "../../Pages/CommonStyle.css";
import {
  getReadableDateDDMMYYYY,
  getReadableDateYYYYMMDD,
  getReadableTime,
} from "../../utils/utils";

import TextField from "@mui/material/TextField";
import axios from "axios";

import { toast } from "react-toastify";
import ic_calendar from "../../images/ic_calendar_invite.svg";
import ic_time from "../../images/ic_time_invite.svg";
import ic_dropdown_invite from "../../images/ic_dropdown_invite.svg";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import { base_url } from "../../utils/AxiosConfig";
import { FiUsers, FiSend, FiChevronDown, FiChevronUp, FiClock, FiCalendar, FiUserPlus } from "react-icons/fi";

const ShowMoreEventsModal = ({
  showMoreModal,
  closeShowMoreEventsModal,
  allEventsArray,
  eventOriginalArray,
}) => {
  const [currentClickedEvent, setCurrentClickedEvent] = useState("");
  const [isCallingEmployeeAPI, setIsCallingEmployeeAPI] = useState(false);
  const [checked, setChecked] = useState([]);
  const [expandedEvents, setExpandedEvents] = useState({});

  const handleToggle =
    (
      eventIdFromClick,
      value,
      imagepathFromClick,
      nameFromClick,
      deptFromClick,
    ) =>
    () => {
      console.log(
        "eventId checked ",
        eventIdFromClick,
        value,
        imagepathFromClick,
      );

      let newObject = {
        eventId: eventIdFromClick,
        invited_member_id: value,
        invited_member_imagepath: imagepathFromClick,
        invited_member_name: nameFromClick,
        invited_member_department: deptFromClick,
      };

      setChecked([newObject]);
    };

  let timeOutEmployeeTyping = null;

  let portNumber = localStorage.getItem("BondTimeportNoData");

  const [toggleEmployeeList, setToggleEmployeeList] = useState(false);
  const [employeeListArray, setEmployeeListArray] = useState(null);

  console.log("allEventsArray", allEventsArray);

  const callEmployeeList = () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    console.log("calling employee list");

    let apiUrLEmployeeLsit = `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`;
    axios
      .get(apiUrLEmployeeLsit)
      .then((res) => {
        setEmployeeListArray(res.data);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  const getProfilePic = (dataFromImagePath) => {
    if (dataFromImagePath) {
      const filePath = dataFromImagePath.replace(/\\/g, "/");
      const fileName = filePath.split("/").pop();
      return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
    }
    return null;
  };

  const handleChange = (e) => {
    if (e.target?.length > 0) {
      setToggleEmployeeList(true);
    }

    console.log(" typed ");

    if (timeOutEmployeeTyping) {
      clearTimeout(timeOutEmployeeTyping);
    }
    timeOutEmployeeTyping = setTimeout(() => {
      console.log(" e ", e.target.value);
    }, 500);
  };

  const clickedonAddMembers = (eventIdFromArrowClick) => {
    console.log("clicked on Add members event id ", eventIdFromArrowClick);
    
    setToggleEmployeeList((prev) => !prev);
    setCurrentClickedEvent(eventIdFromArrowClick);
    
    // Expand the event when adding members
    if (!expandedEvents[eventIdFromArrowClick]) {
      setExpandedEvents(prev => ({ ...prev, [eventIdFromArrowClick]: true }));
    }
  };

  const toggleEventExpand = (eventId) => {
    setExpandedEvents(prev => ({ ...prev, [eventId]: !prev[eventId] }));
  };

  useEffect(() => {
    console.log("toggleEmployeeList", toggleEmployeeList);

    if (toggleEmployeeList) {
      callEmployeeList();
    }
  }, [toggleEmployeeList]);

  const callInvitationAPI = (
    itemFromSendButton,
    empIdFromSendButton,
    empName,
    empDepartment,
  ) => {
    console.log("itemFromSendButton ", itemFromSendButton);

    let filteredEvent = eventOriginalArray.filter(
      (eventOrigy) => eventOrigy.event_id == itemFromSendButton.eventId,
    );

    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const initialObject = {
      cmpcode: companyCode,
      mode: "EDIT",
      event_id: itemFromSendButton.eventId,
      event_name: filteredEvent[0].event_name,
      event_scheduledon: filteredEvent[0].event_scheduledon,
      event_owner_id: empIdFromSendButton,
      evnt_ownder_name: empName,
      event_ownder_dept: empDepartment,
      created_on: filteredEvent[0].created_on,
      evnt_creator_name: filteredEvent[0].event_creator_name,
      event_creator_id: filteredEvent[0].event_creator_id,
      devicetoken_employee: filteredEvent[0].DEVICETOKEN_employee,
      devicetoken_admin: filteredEvent[0].DEVICETOKEN_admin,
      event_status: filteredEvent[0].event_status,
    };

    console.log("object to send to api", initialObject);

    const postBody = JSON.stringify([initialObject]);

    let apiUrl = `${base_url}/api/CRMEvents`;

    axios
      .post(apiUrl, postBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Invitation sent successfully!");
          // Clear checked state after sending
          setChecked([]);
          setToggleEmployeeList(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Failed to send invitation");
      });
  };

  return (
    <Modal 
      show={showMoreModal} 
      onHide={closeShowMoreEventsModal} 
      centered
      size="lg"
      className="modern-events-modal"
    >
      <Modal.Header 
        closeButton 
        className="border-b border-slate-200 px-6 py-4 bg-white rounded-t-2xl"
      >
        <Modal.Title className="flex items-center gap-2">
          <span className="text-2xl">📅</span>
          <div>
            <p className="text-xl font-semibold text-slate-900 mb-0">All Events</p>
            <p className="text-sm text-slate-500 mt-1 mb-0">
              {allEventsArray?.length || 0} upcoming events
            </p>
          </div>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="px-6 py-5 bg-slate-50 max-h-[70vh] overflow-y-auto">
        {allEventsArray && allEventsArray.length > 0 ? (
          <div className="space-y-4">
            {allEventsArray?.map((item, idx) => {
              const isExpanded = expandedEvents[item.eventId];
              const hasSelectedInvitee = checked?.some(
                (sommyAvatar) => sommyAvatar.eventId == item.eventId
              );
              const showEmployeeList = toggleEmployeeList && item.eventId == currentClickedEvent;
              
              return (
                <div 
                  key={idx}
                  className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden"
                >
                  {/* Event Header - Clickable for expand/collapse */}
                  <div 
                    className="p-5 cursor-pointer hover:bg-slate-50 transition-colors"
                    onClick={() => toggleEventExpand(item.eventId)}
                  >
                    <div className="flex items-start justify-between">
                      <h3 className="text-lg font-semibold text-slate-900 mb-3 flex-1">
                        {item.title}
                      </h3>
                      <button className="text-slate-400 hover:text-slate-600 transition-colors">
                        {isExpanded ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
                      </button>
                    </div>

                    {/* Info Cards - Always visible */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {/* Time Card */}
                      <div className="flex items-center gap-3 bg-slate-50 rounded-lg p-3 border border-slate-100">
                        <div className="bg-blue-50 p-2 rounded-lg">
                          <img src={ic_time} className="w-10 h-10 object-contain" alt="time" />
                        </div>
                        <div className="flex-1">
                          <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                            Meeting Time
                          </p>
                          <p className="text-sm font-semibold text-slate-800 mt-1">
                            {getReadableTime(item.start)}
                          </p>
                        </div>
                      </div>

                      {/* Date Card */}
                      <div className="flex items-center gap-3 bg-slate-50 rounded-lg p-3 border border-slate-100">
                        <div className="bg-purple-50 p-2 rounded-lg">
                          <img src={ic_calendar} className="w-10 h-10 object-contain" alt="calendar" />
                        </div>
                        <div className="flex-1">
                          <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                            Meeting Date
                          </p>
                          <p className="text-sm font-semibold text-slate-800 mt-1">
                            {getReadableDateDDMMYYYY(item.start)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Expanded Content - Invitation Section */}
                  {isExpanded && (
                    <div className="border-t border-slate-100 bg-slate-50 p-5">
                      {/* Selected Invitee Display */}
                      {hasSelectedInvitee && (
                        <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-100">
                          <div className="flex items-center justify-between gap-3">
                            <div className="flex items-center gap-3 flex-1">
                              <Avatar 
                                src={getProfilePic(checked[0]?.invited_member_imagepath)}
                                sx={{ width: 40, height: 40 }}
                              />
                              <div>
                                <p className="text-sm font-medium text-slate-900">
                                  {checked[0]?.invited_member_name}
                                </p>
                                <p className="text-xs text-slate-500">
                                  {checked[0]?.invited_member_department}
                                </p>
                              </div>
                            </div>
                            <button
                              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md text-sm"
                              onClick={() =>
                                callInvitationAPI(
                                  item,
                                  checked[0]?.invited_member_id,
                                  checked[0]?.invited_member_name,
                                  checked[0]?.invited_member_department,
                                )
                              }
                            >
                              <FiSend size={16} />
                              Send Invite
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Add Members Button */}
                      {/* <button
                        onClick={() => clickedonAddMembers(item.eventId)}
                        className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-slate-300 hover:border-blue-400 text-slate-700 hover:text-blue-600 rounded-lg font-medium transition-all duration-200 text-sm"
                      >
                        <FiUserPlus size={16} />
                        {showEmployeeList ? "Hide Members" : "Add Members"}
                      </button> */}

                      {/* Employee List */}
                      {showEmployeeList && (
                        <div className="mt-4">
                          <div className="mb-3">
                            <TextField
                              style={{ width: "100%" }}
                              label="Search for members"
                              variant="outlined"
                              size="small"
                              onChange={(e) => handleChange(e)}
                              className="rounded-lg"
                            />
                          </div>
                          
                          {isCallingEmployeeAPI ? (
                            <div className="flex justify-center py-8">
                              <CircularProgress size={40} />
                            </div>
                          ) : (
                            <List
                              dense
                              sx={{
                                width: "100%",
                                maxWidth: "100%",
                                bgcolor: "background.paper",
                                borderRadius: "0.5rem",
                                border: "1px solid #e2e8f0",
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {employeeListArray?.map((value) => {
                                const labelId = `checkbox-list-secondary-label-${value}`;
                                const isChecked = checked
                                  ?.filter((itemChecky) => itemChecky.eventId == item.eventId)
                                  ?.some((sommy) => sommy.invited_member_id == value.EmpId);
                                
                                return (
                                  <ListItem
                                    key={value.EmpId || value.id}
                                    secondaryAction={
                                      <Checkbox
                                        edge="end"
                                        onChange={handleToggle(
                                          item.eventId,
                                          value.EmpId,
                                          value.imagepath,
                                          value.Name,
                                          value.Department,
                                        )}
                                        checked={isChecked}
                                        inputProps={{ "aria-labelledby": labelId }}
                                        sx={{
                                          color: '#3b82f6',
                                          '&.Mui-checked': {
                                            color: '#3b82f6',
                                          },
                                        }}
                                      />
                                    }
                                    disablePadding
                                  >
                                    <ListItemButton>
                                      <ListItemAvatar>
                                        <Avatar 
                                          src={getProfilePic(value.imagepath)}
                                          sx={{ width: 40, height: 40 }}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText 
                                        id={labelId} 
                                        primary={
                                          <span className="font-medium text-slate-900">
                                            {value.Name}
                                          </span>
                                        }
                                        secondary={
                                          <span className="text-xs text-slate-500">
                                            {value.Department}
                                          </span>
                                        }
                                      />
                                    </ListItemButton>
                                  </ListItem>
                                );
                              })}
                            </List>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="bg-slate-100 rounded-full p-4 mb-4">
              <FiCalendar className="text-slate-400 text-3xl" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">No events found</h3>
            <p className="text-sm text-slate-500">There are no upcoming events at this time.</p>
          </div>
        )}
      </Modal.Body>
      
      {/* <Modal.Footer className="border-t border-slate-200 px-6 py-4 bg-white rounded-b-2xl">
        <Button
          onClick={closeShowMoreEventsModal}
          className="px-6 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-all duration-200"
        >
          Close
        </Button>
      </Modal.Footer> */}

      {/* Custom Styles */}
      <style jsx global>{`
        .modern-events-modal .modal-content {
          border-radius: 1rem;
          border: none;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          overflow: hidden;
        }
        
        .modern-events-modal .modal-header .btn-close {
          padding: 0.5rem;
          border-radius: 0.5rem;
          transition: all 0.2s;
        }
        
        .modern-events-modal .modal-header .btn-close:hover {
          background-color: #f1f5f9;
          opacity: 1;
        }
        
        .modern-events-modal .modal-body::-webkit-scrollbar {
          width: 8px;
        }
        
        .modern-events-modal .modal-body::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 4px;
        }
        
        .modern-events-modal .modal-body::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        
        .modern-events-modal .modal-body::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
    </Modal>
  );
};

export default ShowMoreEventsModal;